import React from "react";
import { CopyableInput } from "./copyable-input.tsx";

interface CopyOnceCalloutProps {
  message: string;
  value: string;
}

export function CopyOnceCallout({ message, value }: CopyOnceCalloutProps) {
  return (
    <div className="border-2 border-accent bg-canvas p-4">
      <div className="font-mono text-xs font-bold uppercase tracking-wider text-accent">
        {message}
      </div>
      <div className="mt-3">
        <CopyableInput value={value} />
      </div>
    </div>
  );
}
